import { Link } from "react-router-dom";
import { Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <footer
      className="footer"
      style={{
        marginTop: "30px",
        borderRadius: "10px",
        marginBottom: 0,
        margin: "20px 40px",
      }}
    >
      <Row className="align-items-center justify-content-xl-between">
        <Col xl="12">
          <div
            className="copyright text-center text-xl-left text-muted"
            style={{ paddingLeft: "20px" }}
          >
            © {new Date().getFullYear()}{" "}
            <Link
              to="#"
              className="font-weight-bold ml-1 !text-[#000] "
              rel="noopener noreferrer"
              target="_blank"
            >
              Copyright © 2025 Abhijeet Danve/Rheum Solutions LLC. All rights
              reserved. The A-Tool&copy; is registered with the U.S. Copyright
              Office
            </Link>
          </div>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
